import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-properties-logo-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-properties-logo-svg-icon.component.html',
  styleUrl: './ln-properties-logo-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnPropertiesLogoSvgIconComponent {
  @Input() class = 'w-12 h-9 sm:w-52 sm:h-24';
}
